<template>

    <div class="bg-primary">
        <div class="container">

            <div class="d-flex gap-3">

                <button type="button" class="btn btn-primary fw-bold fs-5 text-uppercase text-white text-nowrap rounded-0" id="menuDropdown" ref="menuDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bi bi-list"></i>
                    {{ __('Alle Kategorien') }}
                    <i class="bi bi-chevron-down"></i>
                </button>
                <div class="dropdown-menu p-0" style="width: 300px">
                    <main-menu />
                </div>

                <ul class="nav flex-row flex-nowrap top-menu">
                    <li class="nav-item" :class="item.class" v-for="item in items">
                        <inertia-link class="nav-link fs-5 text-nowrap link-light text-uppercase fs-5" :href="item.url">
                            <span>
                                {{ item.label }}
                            </span>
                        </inertia-link>
                    </li>
                </ul>

            </div>
        </div>
    </div>

</template>


<script>
    import MainMenu from '@/shared/MainMenu';

    export default {
        props: [
        ],
        components: {
            MainMenu,
        },
        data() {
            return {
                items: [
                    {url: '/kategorien/praxis/abformen', label: this.__('Abformen')},
                    {url: '/kategorien/praxis/anaesthesie', label: this.__('Anästhesie')},
                    {url: '/kategorien/praxis/buero', label: this.__('Büro')},
                    {url: '/kategorien/praxis/services-dienstleistungen', label: this.__('Dienstleistungen')},
                    {url: '/kategorien/mitarbeiterportal', label: this.__('Mitarbeiter'), class: 'highlight'},
                ],
            }
        }
    }
</script>